export default () => {
  const fileInputs = document.querySelectorAll('.js-file-input');

  [...fileInputs].forEach((fileInput) => {
    const label = fileInput.querySelector('.label');
    const defaultLabel = label.innerText;

    fileInput.addEventListener('change', (e) => {
      const { files } = e.target;
      label.innerText = files.length ? files[0].name : defaultLabel;
    });
  });
};
